import { SessionService } from '@agenda-customer-ui/data-access';
import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { COUNTRY_CODE, StorageKeys } from '@core/enums';
import { IUserProfileResponse } from '@core/interface';

@Injectable({
  providedIn: 'root'
})
@Pipe({
    name: 'fdsCurrency',
    standalone: true
})
export class FdsCurrencyPipe implements PipeTransform {

  codeCountry = '';
  withDecimals = false;
  country: string;
  preferredLanguage: string;

  constructor(
    private sessionService: SessionService
  ) {
    const user = this.sessionService.getObject(StorageKeys.USER_PROFILE) as IUserProfileResponse;
    this.preferredLanguage = user.languages?.preferredLanguage ?? '';
    this.country = user.country?.countryCode ?? '';
  }

  #getCurrencyConfig(): IconfigCurrency {
    switch (this.country) {
      case COUNTRY_CODE.BRAZIL:
        this.codeCountry = 'BRL';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.ARGENTINA:
        this.codeCountry = 'ARS';
        break;
      case COUNTRY_CODE.CHILE:
        this.codeCountry = 'CLP';
        break;
      case COUNTRY_CODE.COLOMBIA:
        this.codeCountry = 'COP';
        break;
      case COUNTRY_CODE.ECUADOR:
        this.codeCountry = 'USD';
        this.withDecimals = true;
        break;
      case COUNTRY_CODE.VENEZUELA:
        this.codeCountry = 'VEF';
        break;
      case COUNTRY_CODE.PERU:
        this.codeCountry = 'PEN';
        this.withDecimals = true;
        break;
    }

    return {
      currency: this.codeCountry,
      maximumFractionDigits: this.withDecimals ? 2 : 0
    }
  }

  #getFormatedPrice(price: number): string {
    const configCurrency = this.#getCurrencyConfig();
    const formattedValue = price.toLocaleString(this.preferredLanguage, {
      style: 'currency',
      currency: configCurrency.currency,
      maximumFractionDigits: configCurrency.maximumFractionDigits,
    });

    return formattedValue;
  }

  transform(price: number): string {
    return this.#getFormatedPrice(price);
  }

}

interface IconfigCurrency {
  currency: string;
  maximumFractionDigits: number
}
